import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonConstants } from '@coreconstant';

@Injectable({
    providedIn: 'root'
})
export class ResponseHandlerService {

    constructor(private _toastrService: ToastrService) {
    }

    /**
     * Handles API error responses by identifying the error code and taking appropriate actions such as displaying error messages.
     * @param {any} input - The API error response object or related information to be processed. This can include error codes, messages, and additional related data.
     */
    handleAPIErrorResponse(input: any) {
        if (!input || (typeof input == 'object' && Object.keys(input).length < 1))
            return false;

        // Handle response based on code
        if (input.name && input.name == "HttpErrorResponse")
            input = input.error;

        let code = input.code;
        switch (code) {
            case 201:
            case 500: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 502: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 503: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 404: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 401: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 400: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 403: {
                if (typeof input.message == "string") {
                    this._toastrService.error(input.message);
                } else {
                    this._toastrService.error(CommonConstants.COMMON_ERROR_MESSAGE);
                }
            }
                break;
            case 422:
                {
                    if (typeof input.message == "string") {
                        this._toastrService.error(input.message);
                    } else {
                        if (input.data && input.data.length < 1)
                            return false;

                        let messageString = "";
                        input.data.forEach((element: any) => {
                            messageString += "<div>" + element.message + "</div>";
                        });

                        this._toastrService.error(messageString, "",
                            { enableHtml: true });
                    }
                }
                break;
            default:
                break;
        }
    }

    /**
     * Displays a general error message using a toastr notification.
     * @param {any} input - The error message or data to be displayed.
     */
    showErrorMessageGeneral(input: any) {
        this._toastrService.error(input);
    }

    /**
     * Displays a success message using the toastr service.
     * @param {any} input - The message content to be displayed as a success notification.
     */
    showSuccessMessageGeneral(input: any) {
        this._toastrService.success(input);
    }
}
